// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2iOqH","info":"PatientInfo_info__qESS6"};